import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import 'rc-dropdown/assets/index.css';
import {faCheck, faEdit, faTrash, faFolderPlus } from '@fortawesome/pro-solid-svg-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Modal from '../Modal';
import { useRenameFolderMutation, useDeleteFolderMutation } from '../../features/authentication/assignmentApislice';
import CustomToast from '../Toast';
import FolderCreateModal from '../../pages/assignments/components/FolderCreateModal';
import { useData } from '../../pages/assignments/DataContext';
import deleteMenu from '../../assets/images/deleteMenu.png';

const Index = ({
  allFolders,
  allParents,
  dropdownId,
  selectedId,
  setSelectedFolderId
}) => {
  const [visible, setVisible] = useState(false);
  const [openFolderRenameModel, setOpenFolderRenameModel] = useState(false);
  const [isFolderNameEmpty, setIsFolderNameEmpty] = useState(false);
  const [folderName, setFolderName] = useState('');
  const [editFolderId, setEditFolderId] = useState(0);
  const [confirmModel, setConfirmModel] = useState(false);
  const [openCreateFolderModal, setOpenCreateFolderModal] = useState(false);
  const [selectedFolderName, setSelectedFolderName] = useState('Default Folder');
  const [renameFolder] = useRenameFolderMutation();
  const [deleteFolder] = useDeleteFolderMutation();
  const {setReloadFolders} = useData();
  const [isFolderNameExceeds, setIsFolderNameExceeds] = useState(false);

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleFolderChange = (event) => {
    setSelectedFolderId(parseInt(event.key));
    const folder = allFolders.filter((item) => item.id === parseInt(event.key));
    if (folder.length > 0)
      setSelectedFolderName(folder[0].name);
  };

  const handleFolderRename=(e)=>{
    setIsFolderNameEmpty(false);
    setIsFolderNameExceeds(false);
    setFolderName(e.target.value);
  }; 

  const renameFolderAsync =async()=>{
    if(folderName.length === 0){
      setIsFolderNameEmpty(true);
      return;
    }
    if(folderName.length > 50){
      setIsFolderNameExceeds(true);
      return;
    }
    const options ={
      folderId:editFolderId,
      folderName : folderName
    };
    const response = await renameFolder(options);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Description, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    } else {
      CustomToast('Folder renamed successfully','success');
      setOpenFolderRenameModel(false);
      setEditFolderId(0);
      setSelectedFolderName(folderName);
      setReloadFolders(true);
    }
  };

  const deleteFolderAsync =async()=>{
    const options ={
      folderId:editFolderId
    };
    const response = await deleteFolder(options);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Description, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    } else {
      CustomToast('Folder deleted successfully','success');
      setEditFolderId(0);
      setFolderName('');
      setSelectedFolderId(0);
      setSelectedFolderName('Default Folder');
      setConfirmModel(false);
      setReloadFolders(true);
    }
  };

  const menu = (
    <Menu className='w-100 folder-dropdown' onSelect={(e)=>{handleFolderChange(e);setVisible(false);}}>
      <button
        onClick={()=>setOpenCreateFolderModal(true)}
        className={'btn btn-castleWhite w-100 mb-2'}>
        <FontAwesomeIcon icon={faFolderPlus} className="px-1" />
        Create New Folder
      </button>       
      {allFolders.map((item, index) => (
        <MenuItem key={item.id} className={`${item.id === selectedId?'selected-value':''}`}>
          <div className='form-check d-flex justify-content-between align-items-center'>
            <div className="cursor-pointer">
              <div htmlFor={'check-' + index}>
                {item.name}{' '}
              </div>
            </div>
            {item.id === selectedId ?(
              <div className='px-3'>
                <FontAwesomeIcon className='green-tick' icon={faCheck} />
              </div>
            ):
              <div></div>
            }
            {item.id > 0 &&
            <div className='dropdown-action-btn d-flex gap-1 px-3 d-none'>
              <OverlayTrigger
                key="editToolTip"
                placement="top"
                overlay={<Tooltip className="custom-tooltip">Edit</Tooltip>}>
                <button
                  id={'edit' + index}
                  className="text-info folder-dropdown-icon cursor-pointer bg-white"
                  onClick={()=>{setOpenFolderRenameModel(true);setFolderName(item.name);setEditFolderId(item.id);}}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </OverlayTrigger>
              <OverlayTrigger
                key="deleteToolTip"
                placement="top"
                overlay={<Tooltip className="custom-tooltip">Delete</Tooltip>}>
                <button
                  id={'delete' + index}
                  className="text-danger folder-dropdown-icon cursor-pointer bg-white"
                  onClick={()=>{setConfirmModel(true);setEditFolderId(item.id);setSelectedFolderName(item.name);}}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </OverlayTrigger>
            </div>
            }
          </div>
        </MenuItem>
      ))}
    </Menu>
  );

  return (
    <>
      <div id={dropdownId}>
        <Dropdown
          trigger={['click']}
          onVisibleChange={handleVisibleChange}
          visible={visible}
          closeOnSelect={true}
          overlay={menu}
          overlayClassName='dropdown-style'
          animation="slide-up"
          getPopupContainer={() => document.getElementById(dropdownId)}>
          <div className="form-select d-flex align-items-center">
            <div value={selectedId} className="form-placeholder cursor-pointer overflow-hidden">{selectedFolderName}</div>
          </div>
        </Dropdown>
      </div>
      {openFolderRenameModel &&
      <Modal
        contentWidth="600px"
        isOpen={openFolderRenameModel}
        titleName={'Rename Folder'}
        onClose={() => {setOpenFolderRenameModel(false);setIsFolderNameEmpty(false);setIsFolderNameExceeds(false);}}>
        <p>Folder Name</p>
        <input
          type="text"
          className={`form-control ${isFolderNameEmpty || isFolderNameExceeds ? 'border-danger' : ''}`}
          placeholder=" "
          name="renameFolder"
          id="renameFolder"
          value={folderName}
          onChange={(e)=>handleFolderRename(e)}
        />
        {isFolderNameEmpty &&
        <div className="text-danger">Folder name cannot be empty!</div>
        }
        {isFolderNameExceeds &&
        <div className="text-danger">The Name entered exceeds the maximum length of 50 characters.</div>
        }
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button className="btn btn-castleGray print-btn" onClick={() => {setOpenFolderRenameModel(false);setIsFolderNameEmpty(false);setIsFolderNameExceeds(false);}}>
            Cancel
          </button>
          <button className="btn btn-castleRed print-btn" onClick={() => renameFolderAsync()}>
            Save
          </button>
        </div>
      </Modal>
      }
      <Modal
        isOpen={confirmModel}
        onClose={() => setConfirmModel(false)}
        contentWidth="700px"
        titleName='Delete Folder'
        titleSuffix={`(${selectedFolderName})`}>
        <div className="confirmation-wrapper m-3 pt-3">
          <div className="confirmation-content p-3">
            <div className="confirmation-icon pb-3">
              <img src={deleteMenu} className="img-fluid" />
            </div>
            <div>
              <p className="mb-0">
              Are you sure that you want to delete the folder? Any assignments in this folder will be moved to the Default folder.
              </p>
            </div>
          </div>
          <div className="d-flex justify-content-center gap-2 delete-btn">
            <button className="btn btn-castleWhite" onClick={() => setConfirmModel(false)}>
                No
            </button>
            <button className="btn btn-castleRed" onClick={deleteFolderAsync}>
                Yes
            </button>
          </div>
        </div>
      </Modal>
      {openCreateFolderModal &&
        <FolderCreateModal
          isOpen={openCreateFolderModal}
          onClose={setOpenCreateFolderModal}
          allParents={allParents}
          setSelectedFolderId={setSelectedFolderId}
          setSelectedFolderName={setSelectedFolderName}
          setReloadFolders={setReloadFolders}
        />
      }
    </>
  );
};

Index.propTypes = {
  allFolders: PropTypes.array,
  allParents: PropTypes.array,
  dropdownId: PropTypes.string,
  selectedId: PropTypes.number,
  setSelectedFolderId: PropTypes.func
};

export default Index;
